// Essential for all components
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import {CircularProgress} from '@material-ui/core';
import ErrorMessage from '../../components/100Include/ErrorMessage';
import {setBreadcrumb} from '../../Redux/Action/breadcrumbAction';
import {apiSystemUserTotpCode} from '../../Api/_ApiSystemUserTotpCode';
import {isAdmin} from '../../utils/Utility';
import './SystemUserTotpCode.css';

const POLL_INTERVAL_MS = 1000;

class SystemUserTotpCode extends Component {

    state = {
        code: null,
        secondsRemaining: null,
        error: '',
        loading: true,
    };

    componentDidMount() {
        if (!isAdmin(this.props.auth.userInfo ? this.props.auth.userInfo.role : null)) {
            return;
        }
        this.props.setBreadcrumbP({
            breadcrumbData: [
                {title: 'System User Authenticator Code', link: `/${this.props.i18n.language}/system-user-totp-code`},
                {title: this.props.platform, link: null},
            ]
        });
        this.poll();
        this.interval = setInterval(this.poll, POLL_INTERVAL_MS);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.cancel();
    }

    cancel = () => {
        if (this.request) this.request.cancel();
        this.request = null;
    };

    poll = () => {
        this.cancel();
        const request = axios.CancelToken.source();
        this.request = request;
        apiSystemUserTotpCode.getCode(this.props.platform, request.token)
            .then(res => {
                if (this.request !== request) return;
                if (res && res.status === 200 && res.data) {
                    this.setState({
                        code: res.data.code,
                        secondsRemaining: res.data.seconds_remaining,
                        error: '',
                        loading: false,
                    });
                } else {
                    const error = (res && res.data && res.data.error) || 'Unable to load the authenticator code.';
                    this.setState({error, code: null, secondsRemaining: null, loading: false});
                }
            })
            .catch(error => {
                if (axios.isCancel(error) || this.request !== request) return;
                const message = (error.response && error.response.data && error.response.data.error) || error.message;
                this.setState({error: message, code: null, secondsRemaining: null, loading: false});
            });
    };

    render() {
        const {auth} = this.props;
        if (!auth.auth) {
            return <Redirect to={`/${this.props.i18n.language}/login`} />;
        }
        if (!isAdmin(auth.userInfo ? auth.userInfo.role : null)) {
            return <ErrorMessage message="Admin access required." />;
        }

        const {code, secondsRemaining, error, loading} = this.state;
        return (
            <div className="system-user-totp-code-page">
                <div className="main__container flex-center-item">
                    <Grid container direction="column" alignItems="center" className="totp-code-container">
                        {loading && <CircularProgress />}
                        {!loading && error &&
                            <ErrorMessage message={error} />
                        }
                        {!loading && !error && code &&
                            <React.Fragment>
                                <div className="totp-code-digits" data-testid="totp-code">
                                    {code}
                                </div>
                                <div className="totp-code-countdown">
                                    Refreshes in {secondsRemaining}s
                                </div>
                                <div className="totp-code-hint">
                                    Compare this against the code your authenticator app shows for the same account.
                                </div>
                            </React.Fragment>
                        }
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});
const mapDispatchToProps = dispatch => ({
    setBreadcrumbP: data => dispatch(setBreadcrumb(data)),
});
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SystemUserTotpCode));
